function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".boat_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "boat"
}, /*#__PURE__*/React.createElement("path", {
  className: "boat_fill",
  d: "M70,27.03c-3.07,3.07-4.97,7.31-4.97,12H6v-12H38V15.03h20c-3.07,3.07-4.97,7.31-4.97,12h16.97Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_stroke",
  y1: 39.03,
  x2: 72,
  y2: 39.03
}), /*#__PURE__*/React.createElement("path", {
  className: "boat_stroke",
  d: "M65.03,39.03H6v-12H70c-3.07,3.07-4.97,7.31-4.97,12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "boat_stroke",
  d: "M38,27.03V15.03h20c-3.07,3.07-4.97,7.31-4.97,12"
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_stroke",
  x1: 38,
  y1: 21.03,
  x2: 38,
  y2: 5.03
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_stroke",
  x1: 38,
  y1: 21.03,
  x2: 21.03,
  y2: 4.06
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_stroke",
  x1: 38,
  y1: 21.03,
  x2: 26,
  y2: 0.25
}), /*#__PURE__*/React.createElement("circle", {
  className: "boat_stroke",
  cx: 49,
  cy: 20.03,
  r: 2.32
}));

var SvgBoat = function SvgBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boatIcon",
    viewBox: "-2 -2 76 43.53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boat.7203310f.svg";
export { ForwardRef as ReactComponent };